import { get, post, put } from "../index";
import AdreadRoutes from "./AdRead.Routes";

const AdreadServices = {
  getAllAdreads: async (catId, search, page, limit, type) => {
    let params = `?page=${page}&limit=${limit}&type=${type}`;
    if (catId) params += `&category=${catId}`
    if (search) params += `&title=${search}`
    const result = await get(AdreadRoutes.getAllAdreads + params
    );
    return result;
  },
  createAdread: async (obj) => {
    const result = await post(AdreadRoutes.createAdread, obj);
    return result;
  },

  updateAdread: async (id, obj) => {
    const result = await put(AdreadRoutes.updateAdread + `/${id}`, obj);
    return result;
  }
}

export default AdreadServices;